import useLanguage from "hooks/useLanguage";
import React from "react";

export interface Props {
  videoIds: Record<string, string>;
  id?: string;
  autoPlay?: boolean;
}

const YoutubeVideo: React.FC<Props> = ({ videoIds, id, autoPlay = true }) => {
  const language = useLanguage();

  const videoId = videoIds[language];

  return videoId ? (
    <iframe
      id={id}
      title="iparque-video"
      src={`https://www.youtube-nocookie.com/embed/${videoId}?enablejsapi=1&autoplay=${
        autoPlay ? 1 : 0
      }`}
      width="100%"
      height="100%"
      allow="autoplay;fullscreen"
      frameBorder="0"
    />
  ) : null;
};

export default YoutubeVideo;
